import React, { useEffect, useMemo, useState } from 'react';
import { createContextHook } from '../context';
import { DecodedJwt } from '.';
import { decodeJwtPayload, getJwtToken, subscribeToJwtTokenChange } from './jwt-manager';
import { createUserFromJwt, SelfHostedUser } from './user.types';

export const UserContext = React.createContext<{
  user: SelfHostedUser | null;
  isLoaded: boolean;
}>({
  user: null,
  isLoaded: false,
});

export function UserContextProvider({ children }: any) {
  const [jwt, setJwt] = useState<string | null>(() => getJwtToken());

  useEffect(() => {
    setJwt(getJwtToken());

    return subscribeToJwtTokenChange(() => {
      setJwt(getJwtToken());
    });
  }, []);

  const decodedJwt = useMemo<DecodedJwt | null>(() => decodeJwtPayload<DecodedJwt>(jwt), [jwt]);
  const value = useMemo(
    () => ({
      user: createUserFromJwt(decodedJwt),
      isLoaded: true,
    }),
    [decodedJwt]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export const useUser = createContextHook(UserContext);
